import React from 'react';
import './Header.css';
import btwbLogo from '../../Assets/btwb_logo.svg';
import otherLogo from '../../Assets/madness2020logo.png';

function Header() {
	return(<header className="header relative">
		<div className="header-img absolute w-100 h-100"></div>
		<div className="super-header absolute top-0 mt0 ph3 pt2  w-100 white flex items-center">
			<div className="tl w-50">
				{/*<img className="logo" src={otherLogo} width="250" />*/}
			</div>
			<div className="tr w-50">
				<a href="https://btwb.com">
					<img className="logo" src={btwbLogo} alt="btwb logo" width="175" />
				</a>
			</div>
		</div>
		<div className="header-text absolute mb3 white tl pl3 pr3 z-2 w-50-ns">
				<img className="" src={otherLogo} />
		</div>
		{/*<div className="header-rower absolute bottom-0 left-0 w-40 pl4">
			<img src={rower} />
		</div>*/}
		<div className="header-content absolute pa3 bottom-0 right-0">
			{/*<h1 className="mb4 mt0 tc white f1">The Christmas Row</h1>*/}
			{/*<a className="no-underline db mr0" href="https://btwb.com">
				<div className="header-button pa3 center mb3">Join Us</div>
			</a>*/}
			{/*<a className="no-underline db mr0" href="https://btwb.blog/2019/12/04/marathon-row-challenge/">
				<div className="header-button pa3 center mb3">Details</div>
			</a>*/}
		</div>
	</header>)
}

export default Header;